import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var mutation = gql`
  mutation renameFile($organizationId: UUID!,$flowFileId: UUID!, $name: String!) {
    renameFile(organizationId: $organizationId, flowFileId: $flowFileId, name: $name) 
  }  
`;

export function apiSetFileName(organizationId, flowFileId, name) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, flowFileId, name},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                let data = result.data.renameFile;
                if(data) resolve(data);
                else throw "Unable to set";
            })
            .catch((err) => {
                toast.error("Api Error, Unable to set file name");
                reject(err);
            })
    });
}
